module.exports = __webpack_public_path__ + "static/img/logo3.ad7226de.png";